import React from 'react';
import { Grid, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { displayValue } from '../Requests/requestRows';
import { AssignmentRow, appointmentSummary, configurationSummary } from './assignmentRows';

/**
 * Détail déplié propre à l'étape Affectation.
 *
 * Il ne réutilise pas `RequestDetail` : la maquette de cette étape présente une grille
 * de six champs libellés, là où l'étape Demandes montre quatre colonnes thématiques.
 */
type DetailField = { labelKey: string; value: string };

export default function AssignmentDetail({ row }: { row: AssignmentRow }) {
  const { t, i18n } = useTranslation();

  const fields: DetailField[] = [
    {
      labelKey: 'interventionCreation.assignment.detail.sensorNumber',
      value: displayValue(row.equipment_id)
    },
    {
      labelKey: 'interventionCreation.assignment.detail.moduleNumber',
      value: displayValue(row.device_id)
    },
    {
      labelKey: 'interventionCreation.assignment.detail.configuration',
      value: configurationSummary(row, t)
    },
    {
      labelKey: 'interventionCreation.assignment.detail.cause',
      value: displayValue(row.intervention_cause)
    },
    {
      labelKey: 'interventionCreation.assignment.detail.instructions',
      value: displayValue(row.intervention_instructions)
    },
    {
      labelKey: 'interventionCreation.assignment.detail.appointment',
      value: appointmentSummary(row, t, i18n.language)
    }
  ];

  return (
    <Grid container spacing={2} sx={{ py: 2, px: 2 }}>
      {fields.map((field) => (
        // Trois champs par ligne, comme la maquette : capteur, module, configuration,
        // puis motif, instructions et rendez-vous.
        <Grid item xs={12} sm={6} md={4} key={field.labelKey}>
          <Stack spacing={0.25}>
            <Typography variant="overline" color="text.secondary">
              {t(field.labelKey)}
            </Typography>
            <Typography variant="body2">{field.value}</Typography>
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
}
